import { render, staticRenderFns } from "./streamer-quotes.vue?vue&type=template&id=953e177a&scoped=true&"
import script from "./streamer-quotes.vue?vue&type=script&lang=js&"
export * from "./streamer-quotes.vue?vue&type=script&lang=js&"
import style0 from "./streamer-quotes.vue?vue&type=style&index=0&id=953e177a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953e177a",
  null
  
)

export default component.exports